module.exports = __webpack_public_path__ + "img/gaizao3.deedffc2.png";